// frontend/src/config/auditorFields.ts
// Definición de campos requeridos por el módulo Auditoría Retributiva (RD 902/2020)
// Debe coincidir con STANDARD_TEMPLATE_MAPPING en auditor_api.py

export interface AuditorField {
    key: string;      // Clave interna que espera el backend (ej: "salario_base_anual")
    label: string;    // Texto legible para el usuario (ej: "Salario Base Anual")
    required: boolean;
    tooltip?: string;
    options?: string[]; // Para campos con valores restringidos (Enums)
}

export const AUDITOR_FIELDS: AuditorField[] = [
    { 
        key: 'id_trabajador', 
        label: 'ID Trabajador', 
        required: true, 
        tooltip: 'Identificador único o pseudónimo del empleado.'
    },
    { 
        key: 'sexo', 
        label: 'Sexo', 
        required: true, 
        tooltip: "Debe contener 'Hombre' o 'Mujer'.",
        options: ['Hombre', 'Mujer']
    },
    { 
        key: 'fecha_inicio_contrato', 
        label: 'Fecha Inicio Contrato', 
        required: true, 
        tooltip: 'Fecha de inicio del contrato vigente o antigüedad aplicable al cálculo.'
    },
    { 
        key: 'fecha_fin_contrato', 
        label: 'Fecha Fin Contrato', 
        required: false, 
        tooltip: 'Dejar vacío si el contrato sigue activo al cierre del ejercicio.'
    },
    { 
        key: 'porcentaje_jornada', 
        label: '% Jornada', 
        required: false, 
        tooltip: 'Opcional. Si no se informa, el sistema asumirá jornada completa.'
    },
    { 
        key: 'porcentaje_jornada_reducida', 
        label: '% Jornada reducida', 
        required: false, 
        tooltip: 'Opcional. Si existe, se prioriza para la normalización de jornada.'
    },
    { 
        key: 'agrupacion_1', 
        label: 'Agrupación 1', 
        required: false, 
        tooltip: 'Primera agrupación analítica. Equivale al eje principal actual.'
    },
    { 
        key: 'agrupacion_2', 
        label: 'Agrupación 2', 
        required: false, 
        tooltip: 'Segunda agrupación analítica opcional.'
    },
    { 
        key: 'puesto_trabajo', 
        label: 'Puesto de trabajo', 
        required: false, 
        tooltip: 'Denominación del puesto. Se utiliza para la tabla de trazabilidad de la Agrupación 2.'
    },
    { 
        key: 'salario_base_anual', 
        label: 'Salario Base Anual', 
        required: true, 
        tooltip: 'Importe bruto anual del salario base.'
    },
    { 
        key: 'check_periodo_ref', 
        label: 'Check Periodo Ref.', 
        required: false, 
        tooltip: "Opcional. Si no se facilita, el sistema asumirá 'Dentro'."
    },
    { 
        key: 'check_equiparado', 
        label: 'Check Equiparado', 
        required: false, 
        tooltip: "Opcional. Si no se facilita, el sistema asumirá 'Sí'."
    },
    { 
        key: 'check_n_sc_norm', 
        label: 'Check Nº SC Norm', 
        required: false, 
        tooltip: "Opcional. Si no se facilita, el sistema asumirá 'No'."
    },
    { 
        key: 'check_n_sc_anualiz', 
        label: 'Check Nº SC Anualiz', 
        required: false, 
        tooltip: "Opcional. Si no se facilita, el sistema asumirá 'No'."
    },
    { 
        key: 'check_n_sc_norm_y_anualiz', 
        label: 'Check Nº SC Norm y Anualiz', 
        required: false, 
        tooltip: "Opcional. Si no se facilita, el sistema asumirá 'No'."
    },
    { 
        key: 'check_equiparacion', 
        label: 'Check Equiparación', 
        required: false, 
        tooltip: "Opcional. Si no se facilita, el sistema asumirá 'No'."
    }
];